import React, { useState, useEffect, useRef } from 'react';
import RightCircle from '../../assets/images/common/icons/svg/revamp/24/RightCircle1.svg';
import { Container, Row, Col } from 'reactstrap';
import config from '../../config';
import Swiper from 'swiper';
import { isEmpty } from 'lodash';
import { sanitizedHTML, isExternalURL } from '../../utils/Helper';
import { NavLink } from 'react-router-dom';
// Assets
import './StoryContent.scss';
import '../../assets/css/swiper.min.css';

import '../../widgets/Swiper/Swiper.scss';

const SwiperComponentAutoplay = ({ banners, locale, page }) => {
  const [initBanner, setinitBanner] = useState(false);
  const swiper = useRef(null);

  useEffect(() => {
    swiper.current = new Swiper('#SwiperStory', {
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 24,
      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 24,
          slidesPerView: 2,
        },
        1200: {
          spaceBetween: 24,
          slidesPerView: 3,
        },
      },
      pagination: {
        el: '.swiper-pagination-storyContent',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      loop: true,
      init: false,
    });
  }, []);

  useEffect(() => {
    console.log({ banners, locale });
    if (banners) {
      if (initBanner === false) {
        swiper.current.init();
        setinitBanner(true);
      } else {
        swiper.current.loopDestroy();
        swiper.current.loopCreate();
      }
    }
  }, [locale, banners]);

  return (
    !isEmpty(banners) &&
    banners.length > 0 && (
      <div className="swiper-container" id="SwiperStory">
        <div className="swiper-wrapper">
          {banners.map((item, index) => {
            const company = item.company;
            const title = item.title;
            const external = isExternalURL(item.url);
            const toPath = external ? { pathname: item.url } : item.url;
            const isVideo = item.type === 'videoOnly';
            const dataType = isVideo ? 'video' : null;
            const dataFancybox = isVideo ? '' : null;
            const dataCaption = isVideo
              ? `<h3 class="videoPopUpTitle"><hr />${item.title}</h3>`
              : null;
            const targetType = external ? '_blank' : null;
            const relOptions = external ? 'noreferrer noopener' : null;

            const htmlSection4Title = title && (
              <div>
                <h4
                  className="section4_storyItemTitle"
                  dangerouslySetInnerHTML={{ __html: sanitizedHTML(title) }}
                />
              </div>
            );
            return (
              <div className="swiper-slide" key={index}>
                <div className="swiper-box">
                  <div className="section4_storyItem">
                    <div className="section4_storyItemDiv">
                      <NavLink
                        to={toPath}
                        target={targetType}
                        rel={relOptions}
                        data-fancybox={dataFancybox}
                        data-type={dataType}
                        data-caption={dataCaption}
                      >
                        <img src={item.cover} alt="logo" className="section4_storyItemImg" />
                      </NavLink>
                      <h5 className="section4_storyItemCategory">{item.mainCategory_name}</h5>
                    </div>
                    {htmlSection4Title}
                    {company && <h4 className="section4_storyItemCompanyName">{company}</h4>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};

const StoryItem = ({ data }) => {
  const type = data.type;
  const company = data.company;
  return (
    <div className="section4_storyItem">
      <div className="section4_storyItemDiv">
        <NavLink
          to={type == 'storyPage' ? data.url : { pathname: data.url }}
          target={type == 'storyPage' ? '' : '_blank'}
        >
          <img src={data.cover} alt="logo" className="section4_storyItemImg" />
        </NavLink>
        <h5 className="section4_storyItemCategory">{data.mainCategory_name}</h5>
      </div>
      <h4 className="section4_storyItemTitle">{data.title}</h4>
      {company && <h4 className="section4_storyItemCompanyName">{company}</h4>}
    </div>
  );
};

const StoryContent = ({ data, storyArray, page, locale, homepage }) => {
  const moreInfo = homepage ? homepage.moreInfo : '';
  return (
    <>
      {page == 'home' && storyArray.length > 0 && (
        <div
          className="section4_storyBox"
          style={{ backgroundImage: `url(${data.section4_bgPic})` }}
        >
          <div className="maxWidthContainer globalWidth">
            <div className="section4_storyBoxDiv">
              <div>
                <h2 className="section4_storyTitle">{data.section4_title}</h2>
              </div>
              {homepage && (
                <NavLink to={`${config.routePathTo}/${locale}/story`}>
                  <div className="section4_storyTitleBox">
                    <span className="section4_storyTitleBoxLabel">{moreInfo}</span>
                    <img src={RightCircle} alt="logo" className="section4_storyInfoBtn" />
                  </div>
                </NavLink>
              )}
            </div>
            <SwiperComponentAutoplay banners={storyArray} locale={locale} page={page} />
            <div className="section4_storyBoxSwiperDiv">
              <div className="swiper-pagination-storyContent"></div>
            </div>
          </div>
        </div>
      )}
      {page == 'details' && storyArray.length > 0 && (
        <>
          <div
            className="section4_storyBox"
            style={{ backgroundImage: `url(${data.section4_color})` }}
          >
            <div className="maxWidthContainer globalWidth">
              <div className="section4_storyBoxDiv">
                <h2 className="section4_storyTitle">{data.section4_title}</h2>
              </div>
              <SwiperComponentAutoplay banners={storyArray} locale={locale} page={page} />
              <div className="section4_storyBoxSwiperDiv">
                <div className="swiper-pagination-storyContent"></div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default StoryContent;
